export default __webpack_public_path__ + "static/media/CHUTY.d0f277c0.png";